export default __webpack_public_path__ + "static/media/hniRetirement_final.6493dca8.jpg";